export const PURGE_AUTH = 'logOut'
export const SET_AUTH = 'setUser'
export const SET_TOKEN = 'setUserToken'
export const SET_USER_DATA = 'setUserData'
export const SET_EMPLOYEE_DATA = 'setEmployeeData'
export const SET_USER_BANK_CARD = 'setUserBankCard'
export const SET_USER_BANK_ACCOUNT = 'setUserBankAccount'

export const SET_COMPANY_TYPES = 'setCompanyTypes'
export const SET_CURRENT_BRANCH = 'setCurrentBranch'
export const UPDATE_CURRENT_BRANCH_ID = 'updateCurrentBranchId'
export const RESET_CURRENT_BRANCH = 'ressetCurrentBranch'
export const SET_CURRENT_BRANCH_EMPLOYEES = 'setCurrentBranchEmployees'
export const DELETE_CURRENT_BRANCH_EMPLOYEE = 'deleteCurrentBranchEmployees'
export const SET_COMPANY_BRANCHES = 'setCompanyBranches'
export const SET_SIDEBAR_ITEMS = 'setSidebarItems'
export const SET_CURRENT_BRANCH_PAYMENTS = 'setCurrentBranchPayments'

export const DELETE_EMPLOYEE = 'deleteEmployee'
export const REMOVE_EMPLOYEE_BRANCH = 'removeEmployeeBranch'
